export const loadSortQuery = {
  origin: {
    title: 'Ascending by Origin',
    query: 'start_stop_scheduled_window_started_at+asc',
  },
  destination: {
    title: 'Ascending by Destination',
    query: 'start_stop_scheduled_window_started_at+desc',
  },
  origin_asc: {
    title: 'Ascending by Origin',
    query: 'start_stop_scheduled_window_started_at+asc',
  },
  origin_desc: {
    title: 'Descending by Origin',
    query: 'start_stop_scheduled_window_started_at+desc',
  },
  destination_asc: {
    title: 'Ascending by Destination',
    query: 'end_stop_scheduled_window_started_at+asc',
  },
  destination_desc: {
    title: 'Descending by Destination',
    query: 'end_stop_scheduled_window_started_at+desc',
  },
  posting_asc: {
    title: 'Ascending by Load Posting',
    query: 'last_posted_at+asc',
  },
  posting_desc: {
    title: 'Descending by Load Posting',
    query: 'last_posted_at+desc',
  },
};

export const loadFilterQuery = {
  origin: {
    title: 'Filter by Origin Zipcode',
    query: '&q[start_stop_postal_code_eq]',
  },
  destination: {
    title: 'Filter by Destination Zipcode',
    query: '&q[end_stop_postal_code_eq]',
  },
  pickup: {
    title: 'Filter by origin',
    query: '&q[start_stop_scheduled_window_started_at_date_eq]',
  },
  dropoff: {
    title: 'Filter by destination',
    query: '&q[end_stop_scheduled_window_started_at_date_eq]',
  },
  pickup_start: {
    title: 'Filter by origin',
    query: '&q[start_stop_scheduled_window_started_at_date_gteq]',
  },
  pickup_end: {
    title: 'Filter by origin',
    query: '&q[start_stop_scheduled_window_started_at_date_lteq]',
  },
  dropoff_start: {
    title: 'Filter by destination',
    query: '&q[end_stop_scheduled_window_started_at_date_gteq]',
  },
  dropoff_end: {
    title: 'Filter by destination',
    query: '&q[end_stop_scheduled_window_started_at_date_lteq]',
  },
  equipment: {
    title: 'Filter by equipment',
    query: '&q[equipment_type_in][]',
  },
  trailer: {
    title: 'Filter by trailer type',
    query: '&q[equipment_type_in][]',
  },
  load: {
    title: 'Filter by load type',
    query: '&q[equipment_type_in][]',
  },
  load_id: {
    title: 'Filter by load ID',
    query: '&q[single_external_load_number_equals]',
  },
  // TODO -- update queries below, add posting
  // origin_deadhead: {
  //   title: 'Filter by deadhead',
  //   query: '&q[weight_eq]',
  // },
  // destination_deadhead: {
  //   title: 'Filter by deadhead',
  //   query: '&q[weight_eq]',
  // },
  rate: {
    title: 'Filter by rate',
    query: '&q[rate_type_in][]',
  },
  min_rate: {
    title: 'Filter by minimum rate',
    query: '&q[min_rate_gteq]',
  },
  posted_at_start: {
    title: 'Filter by Posted age',
    query: '&q[last_posted_at_gteq]',
  },
  posted_at_end: {
    title: 'Filter by Posted age',
    query: '&q[last_posted_at_lteq]',
  },
};

export const loadQuery = {
  dispatch: `&per_page=50&q[status_not_in][]=delivered&q[status_not_in][]=cancelled&q[status_not_in][]=assumed_delivered&q[unassigned]=1&q[active_unassigned_with_eld_carrier]=1&q[before_active_tracking_window]=1&q[status_in][]=available`,
  transit: `&per_page=50&q[status_not_in][]=delivered&q[status_not_in][]=cancelled&q[status_not_in][]=assumed_delivered&q[within_active_tracking_window]=1&q[status_in][]=covered&q[status_in][]=progress&q[status_in][]=delayed&q[assigned]=1`,
  completed: `&per_page=50&q[delivered_or_cancelled]=1&q[assigned]=1`,
};

export const createFilterQuery = (filters, existing) => {
  const params = { ...existing };

  if (filters.selectedOrigin) {
    params.origin = filters.selectedOrigin;
  }

  if (filters.selectedDestination) {
    params.destination = filters.selectedDestination;
  }

  if (filters.pickup_start) {
    params.pickup_start = filters.pickup_start;
  } else {
    delete params.pickup_start;
  }
  if (filters.pickup_end) {
    params.pickup_end = filters.pickup_end;
  } else {
    delete params.pickup_end;
  }

  if (filters.origin) {
    params.origin = filters.selectedOrigin;
  } else {
    delete params.origin;
  }
  if (filters.destination) {
    params.destination = filters.selectedDestination;
  } else {
    delete params.destination;
  }

  if (filters.dropoff_start) {
    params.dropoff_start = filters.dropoff_start;
  } else {
    delete params.dropoff_start;
  }
  if (filters.dropoff_end) {
    params.dropoff_end = filters.dropoff_end;
  } else {
    delete params.dropoff_end;
  }

  if (filters.equipment && filters?.equipment?.length > 0) {
    params.equipment = filters.equipment;
  } else {
    delete params.equipment;
  }

  if (filters.rate && filters?.rate?.length > 0) {
    params.rate = filters.rate;
  } else {
    delete params.rate;
  }

  if (filters.trailer) {
    params.trailer = filters.trailer;
  }

  if (filters.load) {
    params.load = filters.load;
  }

  if (filters.min_rate) {
    params.min_rate = filters.min_rate;
  } else {
    delete params.min_rate;
  }

  if (filters.weight) {
    params.weight = filters.weight;
  } else {
    delete params.weight;
  }

  if (filters.trailer_length) {
    params.trailer_length = filters.trailer_length;
  } else {
    delete params.trailer_length;
  }

  if (filters.posting && filters?.posting?.length > 0) {
    if (filters.posting?.includes('all')) {
      delete params.posting;
    }
    params.posting = filters.posting;
  } else {
    delete params.posting;
  }

  if (filters.loadId) {
    params.load_id = filters.loadId;
  } else {
    if (existing.load_id) {
      delete params.load_id;
    }
    if (existing.search) {
      delete params.search;
    }
  }

  if (filters.deadhead) {
    params.deadhead = filters.deadhead;
  } else {
    delete params.deadhead;
  }
  if (filters.origin_deadhead) {
    params.origin_deadhead = filters.origin_deadhead?.replace(' mi', '');
  } else {
    delete params.origin_deadhead;
  }
  if (filters.destination_deadhead) {
    params.destination_deadhead = filters.destination_deadhead?.replace(
      ' mi',
      ''
    );
  } else {
    delete params.destination_deadhead;
  }

  if (filters.status) {
    params.status = 'in_network';
  } else {
    delete params.status;
  }

  if (filters.certifications && filters?.certifications?.length > 0) {
    if (filters.certifications?.includes('hazmat')) {
      params.certifications = 'hazmat';
    }

    if (filters.certifications?.includes('tanker')) {
      params.certifications = 'tanker';
    }

    if (filters.certifications?.includes('none')) {
      delete params.certifications;
    }
  } else {
    delete params.certifications;
  }

  if (filters.searchQuery) {
    params.query = filters.searchQuery;
  } else {
    delete params.query;
  }
  if (filters.company_id) {
    params.company_id = filters.company_id;
  } else {
    delete params.company_id;
  }
  if (filters.team) {
    params.team = filters.team;
  } else {
    delete params.team;
  }
  if (filters.power_only) {
    params.power_only = filters.power_only;
  } else {
    delete params.power_only;
  }
  if (filters.hazmat) {
    params.hazmat = filters.hazmat;
  } else {
    delete params.hazmat;
  }
  if (filters.teams) {
    params.teams = filters.teams;
  } else {
    delete params.teams;
  }

  return params;
};

export const filterKeys = {
  origin: 'Origin',
  destination: 'Destination',
  equipment: 'Equipment',
  trailer: 'Trailer',
  load: 'Load',
  pickup: 'Pickup',
  dropoff: 'Dropoff',
  loadId: 'Load ID',
  rate: 'Rate',
  min_rate: 'Min Rate',
};
